import "@tvg/fuse/styles.css";
import React from "react";
import { hydrateRoot } from "react-dom/client";
import App from "../components/complex-footer/Footer";

const container = document.getElementById("footerRoot");

if (container) {
  hydrateRoot(container, <App {...__INITIAL_STATE_footer__} />);
}
